import React, { FC } from 'react';
import { Bowser } from '@factorin/util';

import { Icon, Label, Text, linkAnchorClass } from 'Modules/ui2/components';
import warning from 'Modules/ui2/icons/warning.sprite.svg';
import { cryptoProPluginDownload, cryptoProLinks } from 'Modules/business/cryptoprofiles';

import { DefaultComponentProps } from '../../types';
import styles from './index.module.scss';


const bowser = new Bowser();

export type PluginNotInstalledProps = Pick<DefaultComponentProps, 't'> & {
    details: string;
}

export const PluginNotInstalled: FC<PluginNotInstalledProps> = ({ t, details }) => (
    <div className={styles.container}>
        <Icon icon={warning} className={styles.icon} size='48' />
        <Label component='h3' weight='demibold' textSize='21-24'>
            {t('plugin.title')}
        </Label>
        <Text component='p' textSize='18'>
            {t('plugin.details', { details })}
        </Text>
        <Text component='p' textSize='18'>
            {t('plugin.description', { link: cryptoProPluginDownload, linkClass: linkAnchorClass })}
        </Text>
        {cryptoProLinks[bowser.name] && (
            <Text component='p' textSize='18'>
                {t('plugin.descriptionAdditional', {
                    additionalLink: cryptoProLinks[bowser.name],
                    linkClass: linkAnchorClass,
                })}
            </Text>
        )}
    </div>
);
